import { Box, Button } from "@mui/material";
import { SubtypeState } from "../../../../types/actionModule/editor/subtypeEditorTypes";
import { useTranslation } from "react-i18next";
import { LinkSubtypeResponse } from "../../../../types/actionModule/subtypes/linkSubtype";

export function LinkEditorPreview(s: SubtypeState) {
    const { t } = useTranslation();

    const subtype = s.properties as Partial<LinkSubtypeResponse>;
    const buttonName = subtype.buttonName;

    return <Box>
        <Button variant="outlined">{buttonName ?? t("actionModules.subtypes.link.previewButtonName")}</Button>
    </Box>
}